import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Wallet } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { StudentPayments } from "@/features/finance/components/student-payments";
// AUTONOMY · Layer 3: ayuda contextual de pagos del alumno.

function PaymentsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="3xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          title={t(msg`My payments`)}
          description={t(
            msg`Your invoices in both currencies with the rate of the day. Offline payments are verified by the academy before they clear your debt.`,
          )}
          icon={Wallet}
        />
      </div>
      <div class="mt-4">
        <StudentPayments />
      </div>
    </PageContainer>
  );
}

export const paymentsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/payments",
  component: withFeatureGate("billing.core", PaymentsPage),
});
